import { render, staticRenderFns } from "./abstract-audit.vue?vue&type=template&id=481c6b90&scoped=true"
import script from "./abstract-audit.vue?vue&type=script&lang=js"
export * from "./abstract-audit.vue?vue&type=script&lang=js"
import style0 from "./abstract-audit.vue?vue&type=style&index=0&id=481c6b90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481c6b90",
  null
  
)

export default component.exports